import React from 'react'

const Saliendo = () => {
  return (
    <div>Saliendo</div>
  )
}

export default Saliendo